import React from "react";

import { styled } from "@mui/material/styles";

const Wrapper = styled("div")(() => ({
  width: "fit-content",
  height: 40,
  padding: "4px 12px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 8,

  borderRadius: 8,
  border: "1px solid #E4E7EC",
}));

const Label = styled("span")(() => ({
  color: "#9CA6AF",
  fontSize: "1.07rem",
  fontWeight: 600,
  lineHeight: "24px",
  fontFamily: "Manrope",
}));

const Value = styled("span")(() => ({
  color: "#465869",
  fontSize: "1.2rem",
  fontWeight: 700,
  lineHeight: "25.2px",
  fontFamily: "Manrope",
}));

interface CardProps {
  label: string;
  value: string;
}

export default function Card(props: CardProps) {
  const { label, value } = props;

  return (
    <Wrapper>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Wrapper>
  );
}
